module.exports = __webpack_public_path__ + "img/Throwing.aa15105d.png";